import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";

const {addClass, removeClass, getAll, get} = $dom

const groupSelector = '.js-sort-group'
const buttonSelector = '.js-sort-button'
const labelSelector = '.js-sort-label'

export default function () {
    const handleClickSort = e => {
        clearActive()
        addClass(e.target.closest('button'), 'sort__active')
        get(labelSelector, groupSelector).textContent =e.target.textContent
    }

    const clearActive = () => {
        const buttons = getAll('button', groupSelector)
        buttons.forEach(item => item.classList.remove('sort__active'))
    }

    return new Component({
        name: 'sort',
        requiredTargets: [groupSelector, buttonSelector, labelSelector],
        onInit() {
            $events.delegate.on('click', buttonSelector, handleClickSort)
        },
        onDestroy() {
            $events.delegate.off('click', buttonSelector, handleClickSort)
        },
    })

}